module.exports = __webpack_public_path__ + "img/P58-zh.7366e48a.png";